import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CoincidenceList from "../CoincidenceList/CoincidenceList";
import { useEffect, useState } from "react";
import './NewOptionDialog.css';
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';import useDebounce from '../../shared/hooks/useDebounce';

interface NewOptionDialogProps {
  onHandleCancel?: () => void;
  onHandleSave?: () => void;
  setOpenDialog: (value: boolean) => void;
  onChangeName?: (value: string) => void;
  setNewName?: any
  newName?: string | null;
  setCoincidentValue?: (value: any | null) => void;
  coincidenceList?: any;
  maxLength?: number;
  uppercase?: boolean;
  openDialog: boolean;
  title: string;
  label: string
  isSearching?: boolean;
  dataTestId?: string;
  isLoading?: boolean
  testId: string
}

const NewOptionDialog: React.FC<NewOptionDialogProps> = ({
  onHandleCancel,
  onHandleSave,
  setOpenDialog,
  onChangeName,
  setNewName,
  newName,
  setCoincidentValue,
  coincidenceList,
  maxLength,
  uppercase,
  openDialog,
  title,
  label,
  isSearching,
  dataTestId,
  isLoading,
  testId
}) => {
  const { t } = useTranslation();
  const [pattern, setPattern] = useState("");
  const [nameDebounced, isDebouncing] = useDebounce(pattern, 300);

  useEffect(() => {
    setNewName('')
  }, [openDialog]);

  useEffect(() => {
    onChangeName?.(nameDebounced)
  }, [nameDebounced]);

  return (
    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      fullWidth
      maxWidth="sm"
      data-testid={dataTestId}
      PaperProps={{ className: 'REQXXI-NewOptionDialog-DialogContainer' }}
    >
      <DialogContent>
        <Typography fontSize="20px">{title}</Typography>
        <TextField
          data-testid='newOptionDialogInput'
          fullWidth
          label={label}
          value={newName}
          onChange={(e) => {
            const value = e.target.value
            setNewName(value)
            setPattern(value)
          }}
          sx={{ mt: '25px' }}
          inputProps={{
            maxLength,
            style: {
              ...(uppercase ? { textTransform: 'uppercase' } : {})
            },
            'data-testid': `${testId}input`
          }}
        />
        {coincidenceList.length > 0 && !isDebouncing && (
          <CoincidenceList coincidenceList={coincidenceList} setCoincidentValue={setCoincidentValue} />
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onHandleCancel}
          data-testid='new-option-dialog-cancel-button' 
        >{t('cancelLabel')}</Button>
        <LoadingButton 
          id="newOptionDialogSaveButton"
          data-testid='new-option-dialog-save-button' 
          onClick={onHandleSave} 
          variant="contained" 
          loading={isLoading} 
          loadingPosition="start" 
          disabled={isSearching || newName == ''}
          startIcon={<SaveIcon />}
        >
          {t('saveLabel')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewOptionDialog;
